export function GetFormEntityObject(
    entityId,
    state,
    answers,
) {
    return {
        entity_id: entityId,
        state: state,
        answers: answers,
    }
}

export function BuildEntityAnswerObjectFromAnswers(answers) {
    let finalAnswers = []
    for ( let i = 0; i < answers.length; i++ ) {
        finalAnswers = [...finalAnswers, GetEntityAnswersObject(
            answers[i].header,
            GetEntityAnswerValueObject(
                answers[i].value.type,
                answers[i].value.text,
            )
        )]
    }

    return finalAnswers
}

function GetEntityAnswersObject(
    header,
    value
) {
    return {
        header: header,
        value: value,
    }
}

function GetEntityAnswerValueObject(
    type,
    text,
    option,
) {
    return {
        type: type,
        text: text,
        option: option,
    }
}

function GetOptionValueObject(
    currentChosen,
    options,
) {
    return {
        current_chosen: currentChosen,
        options: options,
    }
}
